export enum TaxMode {
  Excluding = 'excl',
  Including = 'incl',
}
